module.exports = __webpack_public_path__ + "static/media/A4v6.0a503265.mp3";